<app-dialog-header [title]="'Configuração de dados bancários'"></app-dialog-header>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="container">
      <div class="row my-2">
        <div class="col">
          <div class="form-group">
            <label for="bank_name" class="form-label">Nome do banco</label>
            <input
              id="bank_name"
              type="text"
              class="form-control"
              placeholder="Nome do banco"
              maxlength="100"
              formControlName="bank_name"
              [class.is-invalid]="searchFailed"
              [ngbTypeahead]="banks"
              [inputFormatter]="formatter"
              [resultFormatter]="formatter"
              (selectItem)="handleBankSelect($event)" />
            @if (searching) {
              <small class="form-text text-muted loading">Procurando</small>
            } @else if (banks.length === 0) {
              <small class="form-text text-muted">Nenhum banco foi encontrado.</small>
            }
            @if (searchFailed) {
              <div class="invalid-feedback">Aconteceu algum erro ao buscar os bancos.</div>
            }
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label class="form-label" for="bank_code">Código Banco</label>
            <div>
              <input
                placeholder="000"
                type="text"
                class="form-control"
                id="bank_code"
                maxlength="5"
                formControlName="bank_code"
                [class.is-invalid]="controls.bank_code.touched && controls.bank_code.invalid" />

              @if (controls.bank_code.touched && controls.bank_code.hasError("required")) {
                <div class="text-danger">Esse campo é obrigatório.</div>
              } @else if (controls.bank_code.touched && controls.bank_code.hasError("minlength")) {
                <div class="text-danger">O código do banco deve ter no mínimo 3 dígitos.</div>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="row my-2">
        <div class="col-3">
          <div class="form-group">
            <label class="form-label" for="agency">Agência</label>
            <div>
              <input
                placeholder="Agência"
                type="text"
                class="form-control"
                id="agency"
                maxlength="10"
                formControlName="agency" />

              @if (controls.agency.touched && controls.agency.hasError("required")) {
                <div class="text-danger">Esse campo é obrigatório.</div>
              }
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="form-label" for="account_number">Número</label>
            <div>
              <input
                placeholder="Número"
                type="text"
                class="form-control"
                id="account_number"
                maxlength="10"
                formControlName="account_number" />

              @if (controls.account_number.touched && controls.account_number.hasError("required")) {
                <div class="text-danger">Esse campo é obrigatório.</div>
              }
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label class="form-label" for="account_digit">Dígito</label>
            <div>
              <input
                placeholder="Dígito"
                type="text"
                class="form-control"
                id="account_digit"
                maxlength="1"
                formControlName="account_digit" />

              @if (controls.account_digit.touched && controls.account_digit.hasError("required")) {
                <div class="text-danger">Esse campo é obrigatório.</div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="form-label" for="account_holder">Nome proprietário</label>
            <div>
              <input
                placeholder="Nome proprietário"
                type="text"
                class="form-control"
                id="account_holder"
                maxlength="100"
                formControlName="account_holder" />

              @if (controls.account_holder.touched && controls.account_holder.hasError("required")) {
                <div class="text-danger">Esse campo é obrigatório.</div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="form-label" for="pix_key">Chave Pix</label>
            <div>
              <input
                placeholder="Chave Pix"
                type="text"
                class="form-control"
                id="pix_key"
                maxlength="254"
                formControlName="pix_key" />

              @if (controls.pix_key.touched && controls.pix_key.hasError("required")) {
                <div class="text-danger">Esse campo é obrigatório.</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button styleType="outlined" [disabled]="submitting" (btnClick)="dialogRef.close()">Fechar</app-button>
  <app-button [loading]="submitting" (btnClick)="confirm()">Confirmar</app-button>
</mat-dialog-actions>
